import {
  filterConfigs,
  SearchFilter,
} from '@aibees/elephant/feature/search-filters';
import {
  getFilterTagsFlattened,
  getTags,
} from '@aibees/elephant/feature/search-filters/components/filter-tags/utils';
import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { useSearchQueryFilter } from '@aibees/elephant/hooks/use-search-query-filter';
import { useMemo } from 'react';

export function useFilterValues() {
  const { params } = useSearchQueryFilter();
  const type = useSearchTypeFromRoute();

  return useMemo(() => {
    if (!type) return undefined;
    return filterConfigs[type].flatMap((filter) => {
      const tags = getTags(params, filter as SearchFilter);
      return getFilterTagsFlattened(tags)
        .flatMap((x) => x.data)
        .filter((x) => !!x)
        .map((x) => x);
    });
  }, [params, type]);
}
